export class ErrorMessage {
  public static REQUIRED_FIELDS_MSG = 'برجاء التأكد من ادخال جميع البيانات المطلوبة'
}
